import axios, { AxiosResponse } from "axios";
import { CustomerFeedbackFormModel } from "models/forms/customerFeedbackForm";

export const sendFeedbackForm = async (
  feedback: CustomerFeedbackFormModel
): Promise<AxiosResponse> =>
  axios.post(`${process.env.REACT_APP_API_FEEDBACK_URL}/submit`, feedback);
